<div class="login-register" style="background-image: url(assets/images/background/download.jpg)">
  <div class="login-register-box">
    <mat-card>
      <mat-card-content fxLayoutGap="30px" fxLayoutAlign="center center" fxLayout="column" style="padding: 50px;">
        <h4>Welcome to</h4>
        <div fxLayoutAlign="center center">
          <img src="assets/images/logo-light-text.svg" alt="Situ Logo" fxFlex="100">
        </div>
        <p class="font-14 text-center">Sign your company up to our awesome thing...</p>
        <button mat-flat-button color="primary" (click)="onSignUpClick()">
          <mat-icon>done</mat-icon> Sign Up
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>
